const TASK_ACTIONS = {
  create: 'create',
  update: 'update',
  delete: 'delete',
  get: 'get',
}

const TASK_TYPES = {
  cap: 'cap',
  sharepointSettings: 'sharepointSettings',
  temporaryAccessPassConfig: 'temporaryAccessPassConfig',
  activitybasedtimeoutpolicy: 'activityBasedTimeout',
  secureScoreProfile: 'secureScoreProfile',
  blockSignInOnSharedMailboxes: 'blockSignInOnSharedMailboxes',
  gdap: 'gdap',
  reRegisterMFA: 'reRegisterMFA',
  onboarding: 'onboarding',
  offboarding: 'offboarding',
  updateUser: 'user',
  revokeSessions: 'revokeSessions',
  resetPassword: 'resetPassword',
  subscriptions: 'subscriptions',
  domains: 'domains',
  manageM365Groups: 'manageM365Groups',
  manageSecurityGroups: 'manageSecurityGroups',
  temporaryAccessPass: 'temporaryAccessPass',
  outOfOffice: 'outOfOffice',
  globalAddressList: 'globalAddressList',
  manageEmailForwarding: 'manageEmailForwarding',
  managePowershellAccess: 'managePowershellAccess',
  calendarSharing: 'calendarSharing',
  mailboxAuditActions: 'mailboxAuditActions',
  customerLockbox: 'customerLockbox',
  disableSmtpAuth: 'disableSmtpAuth',
  defenderPolicy: 'defenderPolicy',
  rejectDirectSend: 'rejectDirectSend',
  connectionFilterIpAllowList: 'connectionFilterIpAllowList',
  inboundAntiSpamAllowedDomains: 'inboundAntiSpamAllowedDomains',
  outboundAntiSpamMessageLimits: 'outboundAntiSpamMessageLimits',
  internalSenderAdminNotifications: 'internalSenderAdminNotifications',
  mailTips: 'mailTips',
  connectionFilterSafeList: 'connectionFilterSafeList',
  authenticatorApplicationName: 'authenticatorApplicationName',
  authenticatorDisplayLocation: 'authenticatorDisplayLocation',
  authenticationMethodsPolicy: 'authenticationMethodsPolicy',
  perUserMfa: 'perUserMfa',
  adminConsentWorkflow: 'adminConsentWorkflow',
  passwordRuleSettings: 'passwordRuleSettings',
  applicationRegistrationPolicy: 'applicationRegistrationPolicy',
  tenantCreationPolicy: 'tenantCreationPolicy',
  securityGroupCreationPolicy: 'securityGroupCreationPolicy',
  userOwnedAppsAndServices: 'userOwnedAppsAndServices',
  formsSettings: 'formsSettings',
  guestUserAccessRestricted: 'guestUserAccessRestricted',
  guestUserInvitationsRestricted: 'guestUserInvitationsRestricted',
  thirdPartyStorageServicesRestricted: 'thirdPartyStorageServicesRestricted',
  sharedBookingsRestricted: 'sharedBookingsRestricted',
  zeroHourAutoPurgeTeams: 'zeroHourAutoPurgeTeams',
  groups: 'groups',
  sharePointTenantSettings: 'sharePointTenantSettings',
  securityDefaults: 'securityDefaults',
}

const HUB_TASK_SOURCES = {
  postureBaseline: 'posture-baseline',
  policyManagement: 'policy-management',
  conditionalAccessPolicyBaseline: 'conditional-access-policy-baseline',
  defenderPolicyBaseline: 'defender-policy-baseline',
  intuneDeviceManagementBaseline: 'intune-device-management-baseline',
  intuneAppManagementBaseline: 'intune-app-management-baseline',
  intuneOnboardingBaseline: 'intune-onboarding-baseline',
  groupBaseline: 'group-baseline',
  intuneScriptBaseline: 'intune-script-baseline',
  intuneRemediationScriptBaseline: 'intune-remediation-script-baseline',
  purviewDlpBaseline: 'purview-dlp-baseline',
  purviewRetentionBaseline: 'purview-retention-baseline',
}

module.exports = {
  HUB_TASK_SOURCES,
  TASK_ACTIONS,
  TASK_TYPES,
}
